import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IRoleWisePages } from "../../models/RoleWisePages";
import { IRoleMast } from "../../models/RoleMast";
import { useEffect, useState } from "react";
import { JVCheck } from "../../shared/JVCheck";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface Iprops {
    data: IRoleMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}


export const PagePermissionForm = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState({ tableData: [], loading: true } as { tableData: Array<IRoleWisePages>, loading: boolean });
    const [toggleData, setToggleData] = useState({ view: false, create: false, update: false, export: false, delete: false, show_all_company: false, show_my_company: false, show_mybranch: false });

    const saveToDB = async () => {
        setLoading(true)
        let data = [...tableData.tableData];
        const response = await Fetch("Role_Wise_Pages", "POST", data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success',  detail: "Updated Successfully", life: 3000 });
        }
        setLoading(false)
    }

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("Role_Wise_Pages", "GET", null, `role_id=${props.data.role_ID}`, props.toast);
        if (response) {
            const data: Array<IRoleWisePages> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);
    useEffect(() => {
        if (tableData.tableData.length > 0) {
            checkToggleData();
        }
    }, [tableData]);

    const onHide = () => {
        props.hideDialog();
    }


    const checkToggleData = () => {
        let data = [...tableData.tableData];
        let tview = true, tcreate = true, tupdate = true, texport = true, tdelete = true, tshow_all_company = true, tshow_my_company = true, tshow_mybranch = true;
        for (var i in data) {
            if (!data[i].is_View && tview) {
                tview = false;
            }
            if (!data[i].is_Create && tcreate) {
                tcreate = false;
            }
            if (!data[i].is_Update && tupdate) {
                tupdate = false;
            }
            if (!data[i].is_Export && texport) {
                texport = false;
            }
            if (!data[i].is_Delete && tdelete) {
                tdelete = false;
            }
            if (!data[i].show_all_company && tshow_all_company) {
                tshow_all_company = false;
            }
            if (!data[i].show_my_company && tshow_my_company) {
                tshow_my_company = false;
            }
            if (!data[i].show_mybranch && tshow_mybranch) {
                tshow_mybranch = false;
            }
            if (!tview && !tcreate && !tupdate && !texport && !tdelete && !tshow_all_company && !tshow_my_company && !tshow_mybranch) {
                break;
            }
        }
        setToggleData({ view: tview, create: tcreate, update: tupdate, export: texport, delete: tdelete, show_all_company: tshow_all_company, show_my_company: tshow_my_company, show_mybranch: tshow_mybranch });
    }

    const toggleColumnCheck = (val: boolean, column: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8) => {
        let data = [...tableData.tableData];
        if (column === 1) {
            setToggleData({ view: !toggleData.view, create: toggleData.create, update: toggleData.update, export: toggleData.export, delete: toggleData.delete, show_all_company: toggleData.show_all_company, show_my_company: toggleData.show_my_company, show_mybranch: toggleData.show_mybranch });
            for (var i in data) {
                data[i].is_View = val;
            }
        } else if (column === 2) {
            setToggleData({ view: toggleData.view, create: !toggleData.create, update: toggleData.update, export: toggleData.export, delete: toggleData.delete, show_all_company: toggleData.show_all_company, show_my_company: toggleData.show_my_company, show_mybranch: toggleData.show_mybranch });
            for (var i in data) {
                data[i].is_Create = val;
            }
        } else if (column === 3) {
            setToggleData({ view: toggleData.view, create: toggleData.create, update: !toggleData.update, export: toggleData.export, delete: toggleData.delete, show_all_company: toggleData.show_all_company, show_my_company: toggleData.show_my_company, show_mybranch: toggleData.show_mybranch });
            for (var i in data) {
                data[i].is_Update = val;
            }
        } else if (column === 4) {
            setToggleData({ view: toggleData.view, create: toggleData.create, update: toggleData.update, export: !toggleData.export, delete: toggleData.delete, show_all_company: toggleData.show_all_company, show_my_company: toggleData.show_my_company, show_mybranch: toggleData.show_mybranch });
            for (var i in data) {
                data[i].is_Export = val;
            }
        } else if (column === 5) {
            setToggleData({ view: toggleData.view, create: toggleData.create, update: toggleData.update, export: toggleData.export, delete: !toggleData.delete, show_all_company: toggleData.show_all_company, show_my_company: toggleData.show_my_company, show_mybranch: toggleData.show_mybranch });
            for (var i in data) {
                data[i].is_Delete = val;
            }
        } else if (column === 6) {
            setToggleData({ view: toggleData.view, create: toggleData.create, update: toggleData.update, export: toggleData.export, delete: toggleData.delete, show_all_company: !toggleData.show_all_company, show_my_company: toggleData.show_my_company, show_mybranch: toggleData.show_mybranch });
            for (var i in data) {
                data[i].show_all_company = val;
            }
        }else if (column === 7) {
            setToggleData({ view: toggleData.view, create: toggleData.create, update: toggleData.update, export: toggleData.export, delete: toggleData.delete, show_all_company: toggleData.show_all_company, show_my_company: !toggleData.show_my_company, show_mybranch: toggleData.show_mybranch });
            for (var i in data) {
                data[i].show_my_company = val;
            }
        } else if (column === 8) {
            setToggleData({ view: toggleData.view, create: toggleData.create, update: toggleData.update, export: toggleData.export, delete: toggleData.delete, show_all_company: toggleData.show_all_company, show_my_company: toggleData.show_my_company, show_mybranch: !toggleData.show_mybranch });
            for (var i in data) {
                data[i].show_mybranch = val;
            }
        }
        setTableData({ tableData: data, loading: false });
    }

    const toggleRowCheck = (val: boolean, page_Name_ID?: number) => {
        let data = [...tableData.tableData];
        if (page_Name_ID !== undefined) {
            for (var i in data) {
                if (data[i].page_Name_ID === page_Name_ID) {
                    data[i].is_View = val;
                    data[i].is_Create = val;
                    data[i].is_Update = val;
                    data[i].is_Export = val;
                    data[i].is_Delete = val;
                    data[i].show_all_company = val;
                    data[i].show_my_company = val;
                    data[i].show_mybranch = val;
                }
            }
        }
        setTableData({ tableData: data, loading: false });
    }

    const onCheckChange = (permissionType: number, page_Name_ID?: number) => {
        let data = [...tableData.tableData];
        if (page_Name_ID !== undefined) {
            for (var i in data) {
                if (data[i].page_Name_ID === page_Name_ID) {
                    if (permissionType === 1) {
                        data[i].is_View = !data[i].is_View;
                    } else if (permissionType === 2) {
                        data[i].is_Create = !data[i].is_Create;
                    } else if (permissionType === 3) {
                        data[i].is_Update = !data[i].is_Update;
                    } else if (permissionType === 4) {
                        data[i].is_Export = !data[i].is_Export;
                    } else if (permissionType === 5) {
                        data[i].is_Delete = !data[i].is_Delete;
                    } else if (permissionType === 6) {
                        data[i].show_all_company = !data[i].show_all_company;
                    } else if (permissionType === 7) {
                        data[i].show_my_company = !data[i].show_my_company;
                    } else if (permissionType === 8) {
                        data[i].show_mybranch = !data[i].show_mybranch;
                    }
                    break;
                }
            }
        }
        setTableData({ tableData: data, loading: false });
    }

    const pageNameBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span>{rowData.pageName}</span>
        );
    };
    const ViewBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(1, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.is_View}></JVCheck>
            </span>
        );
    };
    const CreateBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(2, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.is_Create}></JVCheck>
            </span>
        );
    };
    const UpdateBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(3, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.is_Update}></JVCheck>
            </span>
        );
    };
    const ExportBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(4, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.is_Export}></JVCheck>
            </span>
        );
    };
    const DeleteBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(5, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.is_Delete}></JVCheck>
            </span>
        );
    };
    const AllCompanyBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(6, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.show_all_company}></JVCheck>
            </span>
        );
    };
    const MyCompanyBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(7, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.show_my_company}></JVCheck>
            </span>
        );
    };
    const MyBranchBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <span onClick={() => onCheckChange(8, rowData.page_Name_ID)}>
                <JVCheck name={rowData.page_Name_ID?.toString()} defaultValue={rowData.show_mybranch}></JVCheck>
            </span>
        );
    };
    const actionBodyTemplate = (rowData: IRoleWisePages) => {
        return (
            <div className="actions">
                <Button icon="pi pi-check" className="p-button-rounded p-button-outlined p-button-success mr-2" onClick={() => toggleRowCheck(true, rowData.page_Name_ID)} />
                <Button icon="pi pi-times" className="p-button-rounded p-button-outlined p-button-danger" onClick={() => toggleRowCheck(false, rowData.page_Name_ID)} />
            </div>
        );
    };

    const footerTemplate = () => {
        return <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button className="p-button-sm my-1" label="SAVE" onClick={saveToDB} type="button" loading={loading}></Button>
            <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide}></Button>
        </div>
    }

    const viewHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.view, 1)} style={{ marginRight: '2px' }}><JVCheck name="view" defaultValue={toggleData.view}></JVCheck></span>View</>
    }
    const createHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.create, 2)} style={{ marginRight: '2px' }}><JVCheck name="create" defaultValue={toggleData.create}></JVCheck></span>Create</>
    }
    const updateHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.update, 3)} style={{ marginRight: '2px' }}><JVCheck name="update" defaultValue={toggleData.update}></JVCheck></span>Update</>
    }
    const exportHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.export, 4)} style={{ marginRight: '2px' }}><JVCheck name="export" defaultValue={toggleData.export}></JVCheck></span>Export</>
    }
    const deleteHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.delete, 5)} style={{ marginRight: '2px' }}><JVCheck name="delete" defaultValue={toggleData.delete}></JVCheck></span>Delete</>
    }
    const allCompanyHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.show_all_company, 6)} style={{ marginRight: '2px' }}><JVCheck name="allComapny" defaultValue={toggleData.show_all_company}></JVCheck></span>All Company</>
    }
    const myCompanyHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.show_my_company, 7)} style={{ marginRight: '2px' }}><JVCheck name="myComapny" defaultValue={toggleData.show_my_company}></JVCheck></span>My Company</>
    }
    const myBranchHead = () => {
        return <><span onClick={() => toggleColumnCheck(!toggleData.show_mybranch, 8)} style={{ marginRight: '2px' }}><JVCheck name="myBranch" defaultValue={toggleData.show_mybranch}></JVCheck></span>My Branch</>
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={<span style={{ fontWeight: '500', color: 'white', background: 'var(--gray-700)', padding: '1px 5px', borderRadius: '2px' }}>{props.data.role_Name}</span>} footer={footerTemplate} className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="Loading..."
                loading={tableData.loading}
            >
                <Column header="Page Name" body={pageNameBodyTemplate} headerStyle={{ width: '15%' }} />
                <Column header={viewHead} body={ViewBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column header={createHead} body={CreateBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column header={updateHead} body={UpdateBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column header={exportHead} body={ExportBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column header={deleteHead} body={DeleteBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column header={allCompanyHead} body={AllCompanyBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column header={myCompanyHead} body={MyCompanyBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column header={myBranchHead} body={MyBranchBodyTemplate} headerStyle={{ width: '10%' }} />
                <Column body={actionBodyTemplate} headerStyle={{ width: '10%' }} />
            </DataTable>
        </Dialog>
    );
}
